const basicManagement = () => import('@/pages/basic/index')
const carouselManagement = () => import('@/pages/basic/carousel/list')
const carouselEditor = () => import('@/pages/basic/carousel/editor')
const consultManagement = () => import('@/pages/basic/consult/list')
const addConsult = () => import('@/pages/basic/consult/operation')

export default [
  {
    path: '/basic-management',
    component: basicManagement,
    children: [
      {
        path: 'carousel',
        component: carouselManagement,
        meta: [
          {
            name: '轮播图管理',
            url: '/basic-management/carousel'
          }
        ]
      },
      {
        path: 'carousel/add',
        component: carouselEditor,
        meta: [
          {
            name: '轮播图管理',
            url: '/basic-management/carousel'
          },
          {
            name: '新增轮播图',
            url: 'add'
          }
        ]
      },
      {
        path: 'carousel/set/:id',
        component: carouselEditor,
        meta: [
          {
            name: '轮播图管理',
            url: '/basic-management/carousel'
          },
          {
            name: '编辑轮播图',
            url: 'set'
          }
        ]
      },
      {
        path: 'consult-list',
        component: consultManagement,
        name: 'consultManagement',
        meta: [{
          name: '资讯管理',
          url: '/basic-management/consult-list'
        }]
      },
      {
        path: 'consult-list/add',
        component: addConsult,
        name: 'addConsult',
        meta: [{
          name: '资讯管理',
          url: '/basic-management/consult-list'
        },
        {
          name: '新增系统消息推送',
          url: '/basic-management/consult-list/add',
          noCache: true
        }
        ]
      },
      {
        path: 'consult-list/set',
        component: addConsult,
        name: 'addConsult',
        meta: [{
          name: '资讯管理',
          url: '/basic-management/consult-list'
        },
        {
          name: '编辑系统消息推送',
          url: '/basic-management/consult-list/set',
          noCache: true
        }]
      },
    ]
  }
]
